module.exports = __webpack_public_path__ + "img/cz.79984b1b.png";